import WorkOrderServer from "@/api/workorder";
import TicketServer from "@/api/ticket";
import {getResourceBillingStatusChangeWOInfoNoPage} from "@/api/billing";

export function getRequestBody(params, business, extraParams) {
    extraParams = extraParams || {};
    return {
        business: business,
        ...params,
        ...extraParams,
    }
}

export async function findSimpleWorkOrderByLogbook(params) {
    return WorkOrderServer.workOrder.findSimpleByLogbook(getRequestBody(params, 'WORKORDER'));
}

export async function findSimpleChangeByLogbook(params) {
    return WorkOrderServer.workOrder.findSimpleByLogbook(getRequestBody(params, 'CHANGE'));
}

export async function findSimpleIncidentByLogbook(current, size, params, extraParams) {
    return TicketServer.ticket.findSimpleIncidentByLogbook({
        current: current,
        size: size,
        search: getRequestBody(params, 'INCIDENT', extraParams)
    });
}

export async function countIncidentByLogbook(params, extraParams) {
    return TicketServer.ticket.countIncidentByLogbook(getRequestBody(params, 'INCIDENT', extraParams));
}

export async function findBillingUpDownCabinetByLogbook(params) {
    let requestBody = {
        effectiveTimeStart: params.startdate == null ? null : new Date(params.startdate.replace(/-/g, "/")),
        effectiveTimeEnd: params.enddate == null ? null : new Date(params.enddate.replace(/-/g, "/")),
        status:["10", "20", "30","40","50","60"],
        dcnum: params.dcnums
    };
    return getResourceBillingStatusChangeWOInfoNoPage(requestBody);
}
